module.exports = __webpack_public_path__ + "static/Mobile Reg 2-0d7d38fdd8e8df0459b758e70240328b.png";